import { motion } from "framer-motion";
import { Flame, Droplets, Sun, Leaf } from "lucide-react";

const salsas = [
  {
    name: "Macha Original",
    icon: Flame,
    color: "#E07A5F",
    pairings: ["Tacos", "Huevos", "Pasta", "Pizza"],
  },
  {
    name: "Chapultepín",
    icon: Droplets,
    color: "#D4AF37",
    pairings: ["Tostadas", "Carnes asadas", "Mariscos", "Sopas"],
  },
  {
    name: "Habanero Dorado",
    icon: Sun,
    color: "#E5C158",
    pairings: ["Mariscos", "Ceviches", "Pollo", "Hamburguesas"],
  },
  {
    name: "Verde Ancestral",
    icon: Leaf,
    color: "#4A7C59",
    pairings: ["Tacos de canasta", "Enchiladas", "Tamales", "Tostadas"],
  },
];

const containerVariants = { hidden: {}, visible: { transition: { staggerChildren: 0.06 } } };
const itemVariants = { hidden: { opacity: 0, y: 15 }, visible: { opacity: 1, y: 0, transition: { duration: 0.3 } } };

export default function ComoUsarla() {
  return (
    <section data-testid="como-usarla-section" className="relative py-24 md:py-32" style={{ backgroundColor: "#262626" }}>
      <div className="absolute inset-0 opacity-[0.02] pointer-events-none" style={{ backgroundImage: "url('https://grainy-gradients.vercel.app/noise.svg')" }} />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.4 }} className="text-center mb-16">
          <p className="text-sm uppercase tracking-[0.3em] text-[#D4AF37] mb-4">Úsala en todo</p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#F5F5F0] tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            Una salsa, <span className="text-[#E07A5F]">mil posibilidades</span>
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.15 }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {salsas.map((salsa, i) => {
            const Icon = salsa.icon;
            return (
              <motion.div
                key={i}
                variants={itemVariants}
                className="group relative bg-[#1A1A1A] border border-white/[0.04] hover:border-white/10 transition-all duration-500 p-6"
                data-testid={`uso-salsa-${i}`}
              >
                {/* Top accent line */}
                <div className="absolute top-0 left-6 right-6 h-[2px] opacity-40 group-hover:opacity-80 transition-opacity duration-500" style={{ backgroundColor: salsa.color }} />

                {/* Icon + Name */}
                <div className="flex items-center gap-3 mb-5 mt-2">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full" style={{ backgroundColor: `${salsa.color}12` }}>
                    <Icon size={18} style={{ color: salsa.color }} strokeWidth={1.5} />
                  </div>
                  <h3 className="text-base font-semibold text-[#F5F5F0]" style={{ fontFamily: "'Playfair Display', serif" }}>{salsa.name}</h3>
                </div>

                {/* Chips */}
                <div className="flex flex-wrap gap-2">
                  {salsa.pairings.map((p) => (
                    <span
                      key={p}
                      className="text-[11px] px-3 py-1.5 text-[#A3A3A3] border border-white/[0.06] group-hover:border-white/10 transition-colors duration-300"
                      style={{ fontFamily: "'Inter', sans-serif" }}
                    >
                      {p}
                    </span>
                  ))}
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
